import { Component, Input, OnInit, OnChanges, ViewEncapsulation, HostBinding, EventEmitter, Output, SimpleChanges } from '@angular/core';
import { QueryCondition } from '../../entity/querycondition';
import { ControlType } from '../../entity/controltype';
import { SolutionService } from '../../service/solution.service';
import { RadioValue } from '../../entity/controltype/radio/radiovalue';
import { RadioControl } from '../../entity/controltype/radio/radiocontrol';
import { RadioGroupValue } from '../../entity/conditionvalue/radiovalue';

@Component({
    selector: 'app-filter-radio',
    templateUrl: './radio.component.html',
    styleUrls: ['./radio.component.scss']
    // encapsulation: ViewEncapsulation.None
})

export class FilterRadioComponent implements OnInit, OnChanges {

    /**
     * QueryCondition类型
     */
    @Input() item: any;
    @Input() autoLabel: boolean;
    @Input() disabled: boolean;
    @Output('searchHandle') searchHandle = new EventEmitter();
    /**判断是否是在扩展区域展示 */
    extend: boolean = false;
    /**判断是否显示label */
    showlabel: boolean = true;
    radioValue: any[];

    selectCheck = [];

    @HostBinding('class.filter-item-wrap')
    get isExtend(): boolean {
        return !this.extend && this.autoLabel;
    }

    @HostBinding('class.filter-item-checbox-wrap')
    get isCheckExtend(): boolean {
        return !this.extend;
    }

    @HostBinding('class.filter-item-radio') cla = true;
    @HostBinding('class.filter-item-hiddenlabel')
    get hidenLabel(): boolean {
        return !this.showlabel;
    }

    radioDataSource: Array<any> = new Array<any>();
    /**
     * 某个字段发生值变化事件时，需要同步清空的字段，可能不是当前字段
     */
    @Input() changeFields: Array<string> = [];

    constructor(private solutionService: SolutionService) { }

    ngOnInit(): void {
        this.getDataSource();
        this.radioValue = this.item.value.getOriginalValue();
        if (this.item && this.item.control && this.item.control.hasOwnProperty('isExtend')) {
            this.extend = this.item.control.isExtend;
            if (!this.extend) {
                this.showlabel = this.item.control.showLabel;
            }
        }

        this.solutionService.addFilterEditorInstance(this.item.fieldCode, this);

        (this.item.value as RadioGroupValue).clear$.subscribe(() => {
            this.radioValue = [];
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.getDataSource();
        if(changes['changeFields'] && changes['changeFields'].currentValue && !changes['changeFields'].firstChange) {
            const isChange = changes['changeFields'].currentValue.some(field => field == this.item.fieldCode);
            if(isChange){
                let orginalValue=this.item.value.getOriginalValue()
                this.radioValue =orginalValue==undefined?[]:orginalValue;
            }
        }
    }

    getDataSource() {
        if (this.item && this.item.control && this.item.control.getControlType() == ControlType.Radio) {
            let radioList = (this.item.control as RadioControl);
            this.radioDataSource = Array<RadioValue>();

            if (radioList.enumValues && radioList.enumValues.length > 0) {
                radioList.enumValues.forEach(element => {
                    this.radioDataSource.push(Object.assign(new RadioValue(), element));
                });
            }
        }
        // if(this.item && this.item.control && this.item.control.hasOwnProperty('isExtend')){
        //     this.extend = this.item.control.isExtend;
        // }
    }

    // getConditionItemStyle(field: QueryCondition, controlType: any) {
    //     return this.solutionService.getConditionItemStyle(field,controlType);
    // }

    getConditionItemTitle(field: QueryCondition) {
        return this.solutionService.getConditionItemTitle(field);
    }

    onSearch(event) {
        if (event) {
            this.item.value.value = event;
        }
        else {
            this.item.value.value = new RadioGroupValue();
        }
        if (this.disabled) { return; }
        this.searchHandle.emit();
    }
}